import React, { useState } from "react";
import { Fab, IconButton, withStyles } from "@material-ui/core";
import { ReactComponent as VideoIcon } from "../../assets/images/icons/video.svg";
import { ReactComponent as BrochureIcon } from "../../assets/images/icons/brochure.svg";
import { ReactComponent as TechniqueIcon } from "../../assets/images/icons/technique.svg";

import PropTypes, { bool, func } from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { carousel } from "../../store";
import ImageGallery from "react-image-gallery";
import classNames from "classnames";
import { Close as CloseIcon, Label } from "@material-ui/icons";
import ReactPlayer from "react-player";
import styles from "./styles";
import Viewer from "../../components/pdf";
import Logo from "../logo";

import { ReactComponent as PlaquetteIco } from "../../assets/images/icons/plaquette.svg";
import { ReactComponent as PlanIco } from "../../assets/images/icons/plan.svg";
import { ReactComponent as GalerieIco } from "../../assets/images/icons/galeries.svg";
import { ReactComponent as FilmIco } from "../../assets/images/icons/film.svg";
import { ReactComponent as LogoIco } from "../../assets/images/vectuel.svg";
import { ReactComponent as CloseIco } from "../../assets/images/icons/closeSlideShow.svg";
import { ReactComponent as ParkIcon } from "../../assets/images/icons/ios_Car.svg";
import { ReactComponent as ArrowLeftIcon } from "../../assets/images/icons/arrowLeft.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/images/icons/arrowRight.svg";

import { withRouter } from "react-router-dom";
import RightNav from "./partials/RightNav";
import LeftNav from "./partials/LeftNav";
import { version } from "../../config";

function MediaBar({ classes, medias, history }) {
	const [isOpenSlider, setIsOpenSlider] = useState(false);
	const [isOpenVideo, setIsOpenVideo] = useState(false);
	const [isOpenPDF, setIsOpenPDF] = useState(false);
	const [playVideo, setIsPlayVideo] = useState(false);
	const [pauseVideo, setIsPauseVideo] = useState(false);
	const [controls, setControls] = useState(true);

	const [images, setImages] = useState({ title: "", src: [] });
	const [pdf, setPdf] = useState();
	const [video, setVideo] = useState([]);

	const handleVideo = () => {
		setIsOpenVideo(true);
		setVideo(medias["video"]);
	};
	const handleMediaType = type => {
		setIsOpenSlider(true);
		let gallery;
		gallery = medias[type].map(item => ({
			original: item, thumbnail: item
		}));
		setImages({ title: type.split("-").join(" "), src: gallery });
	};
	const handleCloseSlideShow = () => {
		setIsOpenSlider(false);
		setIsOpenVideo(false);
		setImages({});
	};
	const handlePDF = type => {
		setIsOpenPDF(true);
		setPdf(medias[type][0]);
	};

	function galeryOnClick(e){
		let tar = e.target.src

		if(typeof tar !== "undefined" && tar.includes("parking")){
			sessionStorage.setItem("hash", window.location.hash);
			history.push("/lot/parking");
		}

		return false;
	}

	function galeryOnMouseOver(e){
		let tar = e.target.src



		if(typeof tar !== "undefined" && tar.includes("VueParkingAerial_Bouton")){
			e.target.src = "/data/medias/parking/VueParkingAerial_Boutonhover.jpg"
		}
		if(typeof tar !== "undefined" && tar.includes("VueParkingAerial_Boutonhover.jpg")){
			e.target.src = "/data/medias/parking/VueParkingAerial_Bouton.jpg"
		}
		if(typeof tar == "undefined"){
			console.log(e.target)
			if(e.target.firstChild.src?.includes("VueParkingAerial_Boutonhover")){
				e.target.firstChild.src = "/data/medias/parking/VueParkingAerial_Bouton.jpg"
			}
		}

		return false;
	}

	function galeryOnMouseLeave(e){
		let tar = e.target.src
		if(typeof tar !== "undefined" && tar.includes("VueParkingAerial_Boutonhover.jpg")){
			e.target.src = "/data/medias/parking/VueParkingAerial_Bouton.jpg"
		}
	}

	return (
		<div className={classes.mediaBar}>
			<div className={classes.gridContainer}>
				<div className={classes.gridItem}>
					<img src={"assets/images/6eSensImmobilier.png"} className={classes.villePNG} alt={"6eme Sens"} />
				</div>
			</div>
			<div className={classes.gridContainer}>
				<div className={classes.gridItem} onClick={() => handleMediaType("plaquette")} key={"zzzz"}>
					<PlaquetteIco className={classes.img} />
					<span className={classes.textMediabar}>
						Brochure
					</span>
				</div>
				<div className={classes.separatorMediabar}>|</div>
				<div className={classes.gridItem} onClick={() => handleMediaType("image")} key={"ghfiughsdaaaaaaaaaasgf"}>
					<GalerieIco className={classes.img} />
					<span className={classes.textMediabar}>
						galerie
						perspectives
					</span>
				</div>
				<div className={classes.separatorMediabar}>|</div>
				<div className={classes.gridItem} onClick={handleVideo}>
					<FilmIco className={classes.img} />
					<span className={classes.textMediabar}>
						film
					</span>
				</div>
				<div className={classes.separatorMediabar}>|</div>
				<div className={classes.gridItem} onClick={() => handleMediaType("parking")} key={"ghfiughsdaaaaazzzaaaaasgf"}>
					<ParkIcon className={classes.img} />
					<span className={classes.textMediabar}>
						Parking
					</span>
				</div>

			</div>
			<div className={classes.gridItem}>
				<div className={classes.gridItem}>
					<LogoIco className={classes.logoVectuel} />
				</div>
			</div>
			{(isOpenPDF) && (<Viewer
				classes={classNames(classes.mediaSlideShow)}
				file={pdf}
				toggleViewer={() => {
					setIsOpenPDF(false);
				}}
				viewerOpened={isOpenPDF}
				key={"ghfiughsdgidhfgiusndfpnff"}
			/>)}
			{(isOpenSlider || isOpenVideo) && (<div className={classNames(classes.mediaSlideShow)}>
				<div>
					{images.title !== "copyright" && <h6>{images.title}</h6>}
					<IconButton
						aria-label="Close"
						className={classNames(classes.closeSlideShowBtn)}
						onClick={handleCloseSlideShow}
						key={"ghfiughfgdfgfdascwssdgf"}
					>
						<CloseIco className={classes.closeSlideShowBtnIco} />
					</IconButton>
				</div>
				{isOpenSlider && (
					<ImageGallery
						items={images.src}
						showThumbnails={false}
						showFullscreenButton={false}
						showPlayButton={false}
						fullscreen={true}
						key={"ghfiughazeazeazesdgf"}
						originalHeight={"400px"}
						originalWidth={"400px"}
						onClick={galeryOnClick}
						onMouseOver={galeryOnMouseOver}
						onMouseLeave={galeryOnMouseLeave}
						// renderRightNav={(onClick, disabled) => (
						// 	<RightNav onClick={onClick} disabled={disabled} />
						// )}
						// renderLeftNav={(onClick, disabled) => (
						// 	<LeftNav onClick={onClick} disabled={disabled} />
						// )}

					/>)
				}
				{isOpenVideo && (<div className={classNames(classes.officeVersionVideo)}>
					<ReactPlayer
						playing={playVideo}
						controls={controls}
						className={classNames(classes.video, "app-video")}
						url={video}
						width="100%"
						height="100%"
						key={"ghfiughsdgf"}
						onPause={() => {
							setIsPlayVideo(false);
							setIsPauseVideo(true);
						}}
						onPlay={() => {
							setIsPlayVideo(true);
							setIsPauseVideo(true);
						}}
						onClick={() => {
							setIsPlayVideo(!playVideo);
							setIsPauseVideo(true);
							setControls(true);
						}}
					/>
				</div>)}
			</div>)}
		</div>);
}


const mapStateToProps = state => ({
	medias: state.carousel[state.helpers.building]
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchMedia: carousel.fetchMedia }, dispatch);

MediaBar.propTypes = {
	classes: PropTypes.object.isRequired, isMediaShow: PropTypes.string
};

export default withRouter(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(MediaBar))
);
